// 本地存储工具类
class Storage {
  // 设置存储
  static set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.error('Storage set error:', error)
    }
  }

  // 获取存储
  static get(key) {
    try {
      const value = localStorage.getItem(key)
      if (!value) return null
      
      // 尝试JSON解析，失败则返回原始字符串
      try {
        return JSON.parse(value)
      } catch (e) {
        return value
      }
    } catch (error) {
      console.error('Storage get error:', error)
      return null
    }
  }

  // 移除存储
  static remove(key) {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Storage remove error:', error)
    }
  }

  // 清空所有存储
  static clear() {
    try {
      localStorage.clear()
    } catch (error) {
      console.error('Storage clear error:', error)
    }
  }
}

export default Storage